export function shortenString(str, maxLength) {
  if (str.length <= maxLength) return str; // Return the original string if it's short enough
  return str.substring(0, maxLength - 3) + '...'; // Truncate and add ellipsis
}